import type { FaireProductEntity } from "../../entity_types/product";

export const p_q2dn8ztpkx: FaireProductEntity = {
  token: "p_q2dn8ztpkx",
  type: "product",
  name: "NEW FOCUS - Chic Strappy Thong Sandal, Buckle Detail✈️TODAY!",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/2da7904981e96d5833dc0c875d5502bc892be94df1571e31b5daa181a41f2119.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1ed10372ca8e684afd9e9c73bf99069ccfbff16d2190179b38d1de1bdd6c73d4.jpeg",
    "https://cdn.faire.com/fastly/4616490e4189814087a7649e76a88d36195b74b9b248de28f37b9f6f356051a6.jpeg",
    "https://cdn.faire.com/fastly/1f98b5b419e1d1daf78d0a5af73127d91a8d69b2f30ee1734c231d997e425b6c.jpeg",
    "https://cdn.faire.com/fastly/dfadbbd7dc37f50f8272e95680ea0d48693475aa8f1c82765be3e64f0d53c6fa.jpeg",
    "https://cdn.faire.com/fastly/9f79fdcf5ccaf922ee0d9f1787010331d82320fc22d383c1efcbb96c44ac99e2.jpeg",
    "https://cdn.faire.com/fastly/394b684b3fb882e965446fecb9bed45fc3ba0ad5c8606100b9761129ff4d2d84.jpeg",
    "https://cdn.faire.com/fastly/da06368265e6dbed3daad4338f667588f87d9f9f7531e14252e1d9cb3773a8f5.jpeg",
    "https://cdn.faire.com/fastly/07cb7061cd304f3fb17b603a921a84e0981ce77dcdaf4209f74be4431087290f.jpeg",
    "https://cdn.faire.com/fastly/cb42595a45f9df69e5bcaa37acb7bf8cf245777918f6333b199a514e0505e800.jpeg",
  ],
  priceDollars: 9.5,
  description:
    "NEW FOCUS is a modern take on the everyday thong sandal. This sleek flat features a squared toe, slim straps, and subtle metal hardware for a polished finish that feels effortless yet intentional. Designed to be lightweight and easy, it’s the kind of staple you’ll reach for all season long. Simple, versatile, and quietly elevated.\n\nAvailable in Black, Chocolate, Tan, and White.\n\n𝐎𝐎𝐓𝐃\nStyle with relaxed denim and an oversized button-down for an easy off-duty look, or pair with a breezy midi dress for warm-weather days on the go. Finish with sunglasses and a structured tote for an outfit that feels casual, clean, and put-together without overthinking it.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:14.884Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
